export default {
  about_hero_label: '关于 51吃瓜',
  about_hero_title1: '真实爆料',
  about_hero_title2: '权威追踪',
  about_hero_title3: '深度洞察',
  about_intro_title1: '关于',
  about_intro_title2: '51吃瓜每日大赛',
  about_intro_subtitle: '做全网最真实、最及时的吃瓜爆料平台',
  about_intro_paragraph1: '51吃瓜每日大赛成立于2023年，致力于为广大网民提供最新、最全、最真实的娱乐圈和网红圈爆料资讯。我们拥有一支专业的吃瓜追踪团队，7×24小时不间断监控各大社交平台、论坛和私密群组，确保每一条有价值的爆料都能第一时间呈现在您面前。',
  about_intro_paragraph2: '我们坚信"吃瓜亦有道"——每一条爆料都经过多方交叉验证，确保信息的真实性和可靠性。同时，我们始终坚持免费浏览的原则，让每一位瓜友都能无障碍地获取最新资讯。',
  about_features_title1: '为什么选择',
  about_features_title2: '我们',
  about_features_subtitle: '三大核心优势，做最懂你的吃瓜平台',
  about_features_feature1_title: '24小时追踪',
  about_features_feature1_desc: '全天候监控各大平台，不漏任何一条爆料线索，确保时效性行业领先。',
  about_features_feature2_title: '全网聚合',
  about_features_feature2_desc: '整合微博、抖音、小红书、豆瓣等多平台瓜源，一个站点看遍全网。',
  about_features_feature3_title: '免费畅览',
  about_features_feature3_desc: '坚持内容免费开放，不做付费墙，让每一位瓜友都能畅快吃瓜。',
  about_reviews_label: '媒体与瓜友评价',
  about_reviews_title1: '他们都说',
  about_reviews_title2: '我们靠谱',
  about_reviews_subtitle: '来自合作伙伴与真实用户的认可',
  about_cta_title: '有料要爆？马上联系',
  about_cta_subtitle: '如果你有独家爆料线索，欢迎随时向我们投稿',
  about_cta_button: '立即投稿',
};